module.exports = __webpack_public_path__ + "img/4.77103666.jpg";